import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from '@angular/forms';
import {
  ReportGroupModel,
  SiteStepperModel,
  SiteModel,
  GasReportGroupModel
} from 'src/app/models/index';
import {
  SiteService,
  SiteStepperService,
  CommonService
} from 'src/app/services/index';
import {
  SiteStepperEnum,
  ActionModeEnum,
  Moment$,
  Constants,
  AlertService
} from 'src/app/shared';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { LoadMasterComponent } from 'src/app/Components/site/site-master/load-master/load-master.component';
import * as ObjectUtils from 'util';
@Component({
  selector: 'app-report-group',
  templateUrl: './report-group.component.html',
  styleUrls: ['./report-group.component.scss']
})
export class ReportGroupComponent implements OnInit {
  formData: FormGroup;
  formGasGroup: FormGroup;
  stepTitle = 'Energy - Report Grouping Details';
  stepTitleForGas = 'Gas - Report Grouping Details';
  siteId = '';
  gasUtility = true;
  model: ReportGroupModel;
  gasModel: GasReportGroupModel;
  groups: any;
  gasGroups: any;
  gasLoads: any;
  loadDataOfSites: any;
  requiredValidators = [Validators.required, this.startWhitespace];
  siteModel: SiteModel;
  selectedGroup: any;
  gasListData: any;
  // displayedColumns = ['groupName', 'loads'];
  constructor(
    private siteStepperService: SiteStepperService,
    private fb: FormBuilder,
    private cdRef: ChangeDetectorRef,
    private siteService: SiteService,
    private alertService: AlertService,
    private commonService: CommonService,
    public dialog: MatDialog
  ) {
    this.formData = this.fb.group({
      groupNameCtr: [''],
      groupCtr: [''],
      createNewGroupCtr: [],
      loadRIdCtr: ['', [Validators.required]]
    });

    this.formGasGroup = this.fb.group({
      groupName: [''],
      groupId: [''],
      rId: [''],
      kpiName: ['Gas'],
      createNewGroupCtr: [],
      loads: ['', [Validators.required]]
    });

    this.gasListData = new Array();
  }
  public startWhitespace(control: FormControl) {
    if (
      (control.value as string) &&
      (control.value as string).indexOf(' ') == 0
    ) {
      return { whitespace: true };
    }
    return null;
  }
  ngOnInit() {
    this.model = new ReportGroupModel();
    this.siteModel = new SiteModel();
    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (
        data.selectedIndex === SiteStepperEnum.GroupConfiguration &&
        !ObjectUtils.isNullOrUndefined(data.siteModel)
      ) {
        this.siteModel = data.siteModel;
        this.siteId = this.siteModel.siteId;
        this.getGroupsAndLoadsOfSite();
        this.getAllLoadsOfSiteForGroups();

        if (this.siteModel.configuredKpiUtilities.includes('Gas')) {
          this.gasUtility = false;
          this.getGasGroups();
          this.getGasLoads();
          this.fetchGasGroupUtilities();
        }
      }
    });
  }
  public goPrevious = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(
        SiteStepperEnum.ProcessAndLoadDetails,
        this.siteModel
      )
    );
  };
  public goTo = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.ReservesAndSources, this.siteModel)
    );
  };
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formData.get(fieldName).hasError(errorCode);
  };

  /**
   * Method to prompt form field error for Gas report accordion
   *
   * @param {string} fieldName
   * @param {string} errorCode
   * @memberof ReportGroupComponent
   */
  public hasError = (fieldName: string, errorCode: string): boolean => {
    return this.formGasGroup.get(fieldName).hasError(errorCode);
  };

  public onChangeNewGroup = () => {
    switch (this.model.createNewGroup) {
      case 'false': {
        const groupNameCtr = this.formData.get('groupNameCtr');
        const groupCtr = this.formData.get('groupCtr');
        groupNameCtr.setValidators(null);
        groupCtr.setValidators(this.requiredValidators);
        groupNameCtr.updateValueAndValidity();
        groupCtr.updateValueAndValidity();
        break;
      }
      case 'true': {
        const groupNameCtr = this.formData.get('groupNameCtr');
        const groupCtr = this.formData.get('groupCtr');
        groupNameCtr.setValidators(this.requiredValidators);
        groupCtr.setValidators(null);
        groupNameCtr.updateValueAndValidity();
        groupCtr.updateValueAndValidity();
        break;
      }
      default: {
        break;
      }
    }
  };
  public submit = () => {
    const params = {
      siteId: this.siteId,
      groupRId: undefined,
      groupId: undefined,
      loadId: this.model.loadId,
      groupName: ''
    };
    if (this.model.createNewGroup === 'true') {
      params.groupName = this.model.groupname;
    } else {
      if (!this.commonService.isNullOrUndefined(this.selectedGroup)) {
        params.groupRId = this.selectedGroup.rId;
        params.groupId = this.selectedGroup.groupId;
        params.groupName = this.selectedGroup.groupName;
      }
    }

    this.siteService.saveGroupsForSite(params).subscribe((data) => {
      if (data.result === 'Success') {
        this.alertService.message = 'Saved Successfully';
        this.alertService.showSuccess();
        this.getGroupsAndLoadsOfSite();
      } else {
        this.alertService.message = data.message;
        this.alertService.showError();
      }
    });
  };

  /**
   * Method to submit gas report details
   *
   * @return {*}
   * @memberof ReportGroupComponent
   */
  submitGasDetails() {
    if (!this.formGasGroup.valid) {
      return;
    }
    let data = this.formGasGroup.value;
    data.loadId = data.loads.loadId;
    data.siteId = this.siteId;
    if (data.createNewGroupCtr === 'true') {
      delete data.rId;
      delete data.groupId;
    } else {
      data.groupName = data.groupId.groupName;
      data.groupId = data.groupId.groupId;
      delete data.rId;
    }
    delete data.loads;
    delete data.createNewGroupCtr;

    this.siteService.saveUtilityGroupsForSite(data).subscribe((res) => {
      if (res && res.result == 'Success') {
        this.alertService.showSuccess(res.result);
        this.formGasGroup.reset();
        this.fetchGasGroupUtilities();
      } else {
        if (res.result == 'Fail') {
          this.alertService.showError(res.message);
        } else {
          this.alertService.showError(res.result);
        }
      }
    });
  }

  private getGroupsAndLoadsOfSite = () => {
    this.siteService
      .getGroupsAndLoadsBySiteId(this.siteId, false)
      .subscribe((groups) => {
        this.groups = groups;
      });
  };
  private getAllLoadsOfSiteForGroups = () => {
    this.siteService
      .getLoadVerticesOfSiteForGroups(this.siteId)
      .subscribe((data) => {
        this.loadDataOfSites = data;
      });
  };
  public onAddNewLoad = (event: any) => {
    event.preventDefault();
    const dialogConfig: MatDialogConfig = {
      // height: '80%',
      width: '90%'
    };
    // Open View Existing Tags Accordion
    this.dialog.open(LoadMasterComponent, dialogConfig);
  };

  /**
   * Get load vertices od site for gas groups
   *
   * @private
   * @memberof ReportGroupComponent
   */
  private getGasGroups = () => {
    this.siteService
      .getUtilityLoadVerticesOfSiteForGroups(this.siteId, 'Gas')
      .subscribe((groups) => {
        this.gasGroups = groups;
      });
  };

  /**
   * Get loads for gas utility
   *
   * @private
   * @memberof ReportGroupComponent
   */
  private getGasLoads = () => {
    this.siteService
      .getLoadsBasedOnUtility(this.siteId, 'Gas')
      .subscribe((data) => {
        this.gasLoads = data;
      });
  };

  /**
   * Get groups and loads for gas utility
   *
   * @memberof ReportGroupComponent
   */
  fetchGasGroupUtilities() {
    let data = {
      needMeterInfo: false,
      kpiName: 'Gas',
      siteId: this.siteId
    };
    this.siteService.fetchUtilityGroupsAndLoads(data).subscribe((res) => {
      if (res) {
        this.gasListData = res;
      }
    });
  }
}
